import React, { useEffect, useState } from 'react'
import TapHelper from '../../../../services/TapHelper'
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import DateService from '../../../../services/DateService'
import { useDispatch, useSelector } from 'react-redux';
import { apiRunWithAxios } from './APIRunWithAxios';
import Loader from '../../../../components/ui/Loader/Loader';
import { authLoginAndGetJWTToken } from '../../../../store/actions/OmniComm/OmniCommAuthAction';

function StatisticReport({formData}) {

    const dispatch          =   useDispatch();
    const { data }          =   useSelector(state => state.omniAuthLoginReducer);    

    const [movementOperation, setMovementOperation] =   useState({});
    const [fuelData, setFuelData]           =   useState({});
    const [meterReading, setMeterReading]   =   useState({})
    const [loading, setLoading]             =   useState(false)


    useEffect(() => {
        if (data?.jwt) {
            getStatisticData()
        }
    }, [formData, data])
    
    const getStatisticData          =   async () => {
        const startOfDay    =   Math.floor(new Date(formData.date_range_start + " 00:00:00").getTime() / 1000);
        const endOfDay      =   Math.floor(new Date(formData.date_range_end + " 23:59:59").getTime() / 1000);
        
        if(formData.asset_id && startOfDay && endOfDay) {
            const params        =   {
                versionNumber       :   'v1',
                timeBegin           :   startOfDay,
                timeEnd             :   endOfDay,
                dataGroups          :   '[mw, fuel, mnt]',
                vehicles            :   `[${formData.asset_id}]`
            }
            setLoading(pre => !pre);
            setMovementOperation({});
            setFuelData({});
            try {
                let response        =   await apiRunWithAxios("https://online.omnicomm.in/ls/api/v1/reports/statistics", "GET", data?.jwt, params);
                setLoading(false);    
                const results       =   response.data.data;
                setMovementOperation(results.totalMw);
                setFuelData(results?.vehicleDataList[0]['fuel']);
            } catch (error) {
                setLoading(false);
                if(error?.response?.status === 401 && error?.response?.data?.error === "Unauthorized") {
                    swal({
                        title: "Refresh",
                        text: "Please refresh again for fetch statistic data.",
                        icon: "warning",
                        // dangerMode: true,
                        buttons: ["Cancel", "Refresh"],
                    }).then(willDelete => {
                        if (willDelete) {
                            dispatch(authLoginAndGetJWTToken());
                        }
                    });
                }
            } finally {
                setLoading(false);
            }
        }else {
            toast.error('Select asset & time period both are required, for statistic report.', { position: toast.POSITION.TOP_RIGHT });
        }
    }



  return (
    <>
    {
        loading 
        ? <Loader/>
        :
        <>
            <div className="tab_content_wrapper mt-2 my-1">
                <span className="content_heading">Movement and operation</span>
            </div>
            <div className="table-responsive px-3">
                <table className="table table-hover table-bordered">
                    <thead className="table-secondary">
                        <tr>
                            <th className='text-center' style={{ width: "5%" }}>#</th>
                            <th style={{ width: "35%" }}>Name</th>
                            <th style={{ width: "20%" }}>Unit</th>
                            <th style={{ width: "15%" }}>Values</th>
                            <th style={{ width: "25%" }}>-</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-center'>a</td>
                            <td className="fs14 fw-normal" >Mileage</td>
                            <td className='fs14 fw-normal'>km</td>
                            <td className="fs14 fw-normal" >{movementOperation?.totalMileage ? TapHelper.numberFormatter(movementOperation.totalMileage) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>b</td>
                            <td className="fs14 fw-normal" >Maximum speed</td>
                            <td className='fs14 fw-normal'>km/h</td>
                            <td className="fs14 fw-normal" >{movementOperation?.maxSpeed ? TapHelper.numberFormatter(movementOperation.maxSpeed) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>c</td>
                            <td className="fs14 fw-normal">Engine operation time</td>
                            <td className='fs14 fw-normal'>hh:mm:ss</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalWorked)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>d</td>
                            <td className="fs14 fw-normal">Engine operation time</td>
                            <td className="fs14 fw-normal">% of the report period</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalWorkedPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedPercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>e</td>
                            <td className="fs14 fw-normal">Engine operation time in motion</td>
                            <td className="fs14 fw-normal">hour:min:sec</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalWorkedOnMove)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>f</td>
                            <td className="fs14 fw-normal">Engine operation time in motion</td>
                            <td className="fs14 fw-normal">% of the report period</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalWorkedOnMovePercent ? TapHelper.numberFormatter(movementOperation.totalWorkedOnMovePercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>g</td>
                            <td className="fs14 fw-normal">Engine operation time motionless</td>
                            <td className="fs14 fw-normal">hour:min:sec</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalWorkedNoMovementTime)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>h</td>
                            <td className="fs14 fw-normal">Engine operation time motionless</td>
                            <td className="fs14 fw-normal">% of the report period</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalWorkedNoMovementPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedNoMovementPercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        {/* <tr>
                            <td className='text-center'>i</td>
                            <td className="fs14 fw-normal">Engine operation idle time</td>
                            <td className="fs14 fw-normal">hour:min:sec</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalWorkedOnIdlingRPM)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>j</td>
                            <td className="fs14 fw-normal">Engine operation idle time</td>
                            <td className="fs14 fw-normal">% of engine operation time</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalWorkedOnIdlingRPMPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedOnIdlingRPMPercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>k</td>
                            <td className="fs14 fw-normal">Engine operation time at normal RPM</td>
                            <td className="fs14 fw-normal">hour:min:sec</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalWorkedOnNormalRPM)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>

                        <tr>
                            <td className='text-center'>l</td>
                            <td className="fs14 fw-normal">Engine operation time at normal RPM</td>
                            <td className="fs14 fw-normal">% of engine operation time</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalWorkedOnNormalRPMPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedOnNormalRPMPercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>m</td>
                            <td className="fs14 fw-normal">Engine operation time at maximum RPM</td>
                            <td className="fs14 fw-normal">hour:min:sec</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalWorkedOnExcessRPM)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>n</td>
                            <td className="fs14 fw-normal">Engine operation time at maximum RPM</td>
                            <td className="fs14 fw-normal">% of engine operation time</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalWorkedOnExcessRPMPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedOnExcessRPMPercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>o</td>
                            <td className="fs14 fw-normal">Engine operation time under load</td>
                            <td className="fs14 fw-normal">hour:min:sec</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalWorkedUnderLoadRPM)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>p</td>
                            <td className="fs14 fw-normal">Engine operation time under load</td>
                            <td className="fs14 fw-normal">% of engine operation time</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalWorkedUnderLoadRPMPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedUnderLoadRPMPercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr> */}
                        <tr>
                            <td className='text-center'>i</td>
                            <td className="fs14 fw-normal">Time with the engine switched off</td>
                            <td className="fs14 fw-normal">hour:min:sec</td>
                            <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalLayUpTime)}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>j</td>
                            <td className="fs14 fw-normal">Time with the engine switched off</td>
                            <td className="fs14 fw-normal">% of engine operation time</td>
                            <td className='fs14 fw-normal'>{movementOperation?.totalLayUpTimePercent ? TapHelper.numberFormatter(movementOperation.totalLayUpTimePercent) : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div className="tab_content_wrapper mt-3 my-1">
                <span className="content_heading">Fuel (main tank)</span>
            </div>
            <div className="table-responsive px-2 pb-5">
                <table className="table table-hover table-bordered my-1">
                    <thead className="table-secondary">
                        <tr>
                            <th className='text-center' style={{ width: "5%" }}>#</th>
                            <th style={{ width: "35%" }}>Name</th>
                            <th style={{ width: "20%" }}>Unit</th>
                            <th style={{ width: "20%" }}>Values</th>
                            <th style={{ width: "20%" }}>-</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-center'>a</td>
                            <td className="fs14 fw-normal" >Initial volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.startVolume ? fuelData?.startVolume/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>b</td>
                            <td className="fs14 fw-normal" >Refueling volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.refuelling ? fuelData.refuelling/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>c</td>
                            <td className="fs14 fw-normal" >Draining volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.draining ? fuelData.draining/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>d</td>
                            <td className="fs14 fw-normal" >Final volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.endVolume ? fuelData.endVolume/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>e</td>
                            <td className="fs14 fw-normal" >Actual consumption</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.fuelConsumption ? fuelData.fuelConsumption/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>f</td>
                            <td className="fs14 fw-normal" >Actual mileage per 1 l</td>
                            <td className='fs14 fw-normal'>km</td>
                            <td className="fs14 fw-normal">
                                {(fuelData.fuelConsumption/10) !== 0 && movementOperation?.totalMileage ? TapHelper.numberFormatter(((movementOperation.totalMileage) / (fuelData.fuelConsumption/10))) : ''}
                            </td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        {/* <tr>
                            <td className='text-center'>g</td>
                            <td className="fs14 fw-normal" >Actual fuel consumption per 1 hour of engine operation</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal">
                                {fuelData?.fuelConsMH ? TapHelper.numberFormatter((fuelData.fuelConsMH/10), 1) : ''}
                            </td>
                            <td className='fs14 fw-normal'></td>
                        </tr> */}
                        <tr>
                            <td className='text-center'>g</td>
                            <td className="fs14 fw-normal" >Actual fuel consumption per engine hour</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal">
                                {fuelData?.fuelConsPerMotorhour ? TapHelper.numberFormatter((fuelData.fuelConsPerMotorhour/10), 1) : ''}
                            </td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    }
    </>
  )
}

export default StatisticReport